import {
  CatalogSearchResultItem,
  ColumnDefinition,
  FieldRenderer,
} from '../types';
import { DevHubLink } from '@devxdiscover/devhub-ui';
import { NavLink } from 'react-router-dom';
import { Column } from 'primereact/column';

const ownerLinkTemplate = (row: CatalogSearchResultItem) => {
  return (
    <DevHubLink
      component={NavLink}
      to={`/catalog/${row?.ownerOrg?.split('/').join('/group/')}`}
    >
      {row.ownerOrg}
    </DevHubLink>
  );
};

/**
 * Renders the owner org field
 * @param col The column definition
 * @param index The index of the column
 */
export const ownerOrgRenderer: FieldRenderer = (
  col: ColumnDefinition,
  index: number,
) => {
  return (
    <Column
      key={index}
      field={col.field}
      header={col.header}
      style={{ width: col.width }}
      body={ownerLinkTemplate}
    />
  );
};
